// Demo-mode switch. When on, apiRequest never touches the network — every read is served
// from src/demo fixtures and every write is rejected with a friendly read-only error.
//
// This module must stay import-free (client.ts depends on it; importing client back would
// create a cycle), so the storage keys client.ts owns are duplicated here by value.

const DEMO_FLAG_KEY = 'aima.demo';
const TOKEN_KEY = 'aima.token'; // must match client.ts
const TOKEN_BACKUP_KEY = 'aima.token.beforeDemo';
const CURRENT_ORG_KEY = 'aima.currentOrgId'; // must match OrgContext.tsx

/** Placeholder bearer so AuthContext's "only fetch /me when a token exists" logic runs. */
export const DEMO_TOKEN = 'demo-session';

export const DEMO_READ_ONLY_MESSAGE =
  'The demo workspace is read-only. Create your own workspace to run live analyses on your repositories.';

export function isDemoMode(): boolean {
  try {
    return localStorage.getItem(DEMO_FLAG_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Turn demo mode on. A real session's token (if any) is parked and restored on exit,
 * so trying the demo never logs a real user out.
 */
export function enterDemoMode(): void {
  const existing = localStorage.getItem(TOKEN_KEY);
  if (existing && existing !== DEMO_TOKEN) {
    localStorage.setItem(TOKEN_BACKUP_KEY, existing);
  }
  localStorage.setItem(TOKEN_KEY, DEMO_TOKEN);
  localStorage.setItem(DEMO_FLAG_KEY, '1');
  // The demo org id would otherwise leak into the restored real session's org picker.
  localStorage.removeItem(CURRENT_ORG_KEY);
}

export function exitDemoMode(): void {
  localStorage.removeItem(DEMO_FLAG_KEY);
  localStorage.removeItem(CURRENT_ORG_KEY);
  const backup = localStorage.getItem(TOKEN_BACKUP_KEY);
  localStorage.removeItem(TOKEN_BACKUP_KEY);
  if (backup) {
    localStorage.setItem(TOKEN_KEY, backup);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
}
